import OrderService from 'src/common/api/order.service';
import InvoiceService from 'src/common/api/invoice.service';

export async function submitOrder(context, payload) {
  const response = await OrderService.post(payload);
  if (response.status === 200) {
    return response;
  }

  return null;
}

export async function fetchInvoice(context, id) {
  const response = await InvoiceService.get(id);
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function initPayment(context, data) {
  const response = await OrderService.initPayment(data);
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function processPayment3dSecure(context, data) {
  const response = await OrderService.processPayment3dSecure(data);
  if (response.status === 200) {
    return response.data;
  }

  return null;
}

export async function finalizePayment(context, data) {
  const response = await OrderService.finalizePayment(data);
  if (response.status === 200) {
    return response.data;
  }

  return null;
}
